import React from 'react';
import { Provider } from 'react-redux';
import Routes from './Containers';
import Store from './Store';
import Layout from './Components/Layout';
import './App.css';
import { IRoute } from './Containers';
import Home from './Containers/Home';
import AnnouncedShipment from './Containers/AnnouncedShipment';
import Stacking from './Containers/Stacking';
import Consolidate from './Containers/Consolidate';
import BreakBulk from './Containers/BreakBulk';
import Bath from './Containers/Bath';
import Yard from './Containers/Yard';
import AccountContainer from './Containers/Account';
import ViewerManual from './Components/ViewerManual';

const routes: IRoute[] = [
	{
		name: 'home',
		path: '/',
		component: <Home />,
		exact: true
	},
	{
		name: 'announcedshipment',
		path: '/carga-anunciada',
		component: <AnnouncedShipment />
	},
	{
		name: 'stacking',
		path: '/stacking',
		component: <Stacking />
	},
	{
		name: 'consolidate',
		path: '/consolidado',
		component: <Consolidate />
	},
	{
		name: 'breakbulk',
		path: '/break-bulk',
		component: <BreakBulk />
	},
	{
		name: 'cobreloteado',
		path: '/cobre-loteado',
		component: <Bath />
	},
	{
		name: 'cobrealmacenado',
		path: '/cobre-almacenado',
		component: <Yard />
	},
	{
		name: 'var',
		path: '/administration',
		component: <AccountContainer />
	},
	{
		name: 'manual',
		path: '/manual',
		component: <ViewerManual />
	}
];

const App: React.FC = () => {
	return (<Provider store={Store} >
		<Layout>
			<Routes routes={routes} />
		</Layout>
	</Provider>
	);
}

export default App;
